export default __webpack_public_path__ + "static/media/IMG_8676.e4ca5634.JPG";